import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ServicingFunctionIdType, ServicingPageIdType } from '@common/interfaces';
import { ServicingCommonStoreService } from '@common/services';
import { MyBookingService } from '@common/services/my-booking/my-booking.service';
import { SupportModalBlockComponent } from '@lib/components/support-class';
import { CommonLibService, ModalService } from '@lib/services';
import { Subscription } from 'rxjs';
import { GetOrderResponseData, GetOrderResponseDataLinkedOrdersInner } from 'src/sdk-servicing';
import { addLinkedPayloadParts } from './add-linked/add-linked-payload.state';

@Component({
  selector: 'asw-linked-modal',
  templateUrl: './linked-modal.component.html',
  styleUrls: ['./linked-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkedModalComponent extends SupportModalBlockComponent {
  subPageId: string = ServicingPageIdType.MY_BOOKING;
  subFunctionId: string = ServicingFunctionIdType.BOOKING_CONFIRMATION;
  // 1.3 関連PNR一覧(モーダル)
  linkedOrders: Array<GetOrderResponseDataLinkedOrdersInner> = [];

  subscription: Subscription = new Subscription();
  constructor(
    private _common: CommonLibService,
    private _myBookingService: MyBookingService,
    private readonly _router: Router,
    private _modalService: ModalService,
    private _servicingCommonStoreService: ServicingCommonStoreService
  ) {
    super(_common);
    this.closeWithUrlChange(this._router);
  }

  reload(): void {}
  /** (40) 予約メニューボタン押下処理 */
  init(): void {
    // 1.	予約メニューモーダルを表示する。
    this.subscription.add(
      this._servicingCommonStoreService.getServicingCommonModel$().subscribe((servicingCommon) => {
        const pnr = servicingCommon.getOrder as GetOrderResponseData;
        this.linkedOrders = pnr?.linkedOrders ?? [];
      })
    );
    this.subscription.add(
      this._myBookingService.getAddReservation().subscribe((res) => {
        if (res) {
          this.close();
        }
      })
    );
  }

  // (16) 関連PNR一覧(ヘッダ)、関連PNR一覧(モーダル)ボタン押下処理
  refreshData({ orderId, travelerName }: GetOrderResponseDataLinkedOrdersInner) {
    // 1.	以下処理にて、関連PNR特定処理を行う。
    // 1.1.	PNR情報取得API応答.data.linkedOrderについて、
    // 当該linkedOrder.orderId=画面.関連PNR一覧(モーダル).valueとなる当該linkedOrderを抽出し、以下処理を行う。
    // 1.1.1.	当該linkedOrder.orderIdを関連PNR予約番号として保持する。
    // 1.1.2.	当該linkerOrder.travelerNameを”/”で区切り、前半を関連PNR搭乗者姓、後半を関連PNR搭乗者名として保持する。
    const names = travelerName?.split('/') ?? [];
    const firstName = names[1] ?? '';
    const lastName = names[0] ?? '';

    // 2.	以下の内容を設定し、初期表示のイベントID(1)を行う。
    this._common.aswServiceStoreService.updateAswService({
      orderId,
      travelDocumentId: '',
      lastName,
      firstName,
    });

    // run init S01-P030
    this._myBookingService.runOnInit();
    this.close();
  }

  destroy(): void {
    this._myBookingService.setAddReservation(false);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  /** (17) 関連PNR追加エリア表示ボタン押下処理 */
  onAddReservation() {
    // 1.	関連PNR追加エリアモーダル表示状態をstoreで管理し、表示する旨を通知することによって関連PNR追加エリアをモーダル表示する。
    this._modalService.showSubModal(addLinkedPayloadParts());
  }

  // (20) 関連PNRモーダル閉じる
  clickClose() {
    // 1.	関連PNRモーダルを非表示にする。
    // ※表示状態をstoreで管理し、非表示にする旨を通知することによって非表示にする。
    this.close();
  }

  getClassLinked() {
    const trimText = this.lmodalContentsClassWithWidth.trim();
    return this.lmodalContentsClassWithWidth + trimText + '--bg-gray5';
  }
  get isEmpty() {
    return this.linkedOrders && this.linkedOrders.length === 0;
  }
}
